module.exports = __webpack_public_path__ + "static/media/canaryLogo_text-img.82c56eb4.png";